import { Route, Routes } from "react-router-dom";
import { AuthLayout } from "./AuthLayout";
import { LoginPage } from "./login/LoginPage";
import { RegistrationPage } from "./registration/RegistrationPage";
import { ForgotPasswordPage } from "./forgotPassword/ForgotPasswordPage";

const AuthPage = () => (
  <Routes>
    <Route element={<AuthLayout />}>
      <Route path="login" element={<LoginPage />} />
      <Route path="login/:emailAddress" element={<LoginPage />} />
      <Route path="registration" element={<RegistrationPage />} />
      <Route path="registration/:emailAddress" element={<RegistrationPage />} />
      <Route path="forgot-password" element={<ForgotPasswordPage />} />
      <Route path="forgot-password/:emailAddress" element={<ForgotPasswordPage />} />
      <Route index element={<LoginPage />} />
    </Route>
  </Routes>
);

export { AuthPage };
